import { render, staticRenderFns } from "./LineClassDay.vue?vue&type=template&id=08387575&scoped=true&"
import script from "./LineClassDay.vue?vue&type=script&lang=js&"
export * from "./LineClassDay.vue?vue&type=script&lang=js&"
import style0 from "./LineClassDay.vue?vue&type=style&index=0&id=08387575&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08387575",
  null
  
)

export default component.exports